// @flow
import * as motivationContent from "./motivationContent";

export default motivationContent;
